export default __webpack_public_path__ + "static/media/background-5.0fcc2f29.jpg";